<template>
    <div class="main-content">
        <div class="profile-icon">
            <img id="profile-icon-img" :src="url"/>
        </div>
        <div class="profile-brief-item profile-name" >
            {{ name }}
        </div>
        <div class="profile-brief-item profile-description">
            {{ des }}
        </div>
        <button class="tube-button profile-button profile-brief-item" :class="{'hide':relation!==1 && existingUser}" @click='initChat'>chat</button>
        <div class='blank' :class="{'hide':relation!==1 && existingUser}"></div>
        <button class="tube-button profile-button profile-brief-item" :class="{'hide':relation!==1 && existingUser}" @click='deleteContact'>delete</button>
        <div class='blank' :class="{'hide':relation!==1 && existingUser}"></div>
        <button class="tube-button profile-button profile-brief-item" :class="{'hide':relation!==0 && existingUser}" @click='addContact'>add as friend</button>
        <div class='blank' :class="{'hide':relation!==2 && existingUser}"></div>
        <button class="tube-button profile-button profile-brief-item" :class="{'hide':relation!==2 && existingUser}" @click='switchChangeSheet'>change Info</button>
        <div class='blank' :class="{'hide':!this.showSheet}" ></div>
        <input class="inputfile" type="file" id='upload' name="upload" accept="image/jpeg" :class="{'hide':!this.showSheet}" :disabled='sending'>
        <label class="profile-brief-item tube-button" for="upload" :class="{'hide':!this.showSheet}" :disabled='sending'>Choose a photo</label>

        <div class='blank' :class="{'hide':!this.showSheet}" ></div>
        <input class="tube-input profile-brief-item" v-model="newName" placeholder="new username" type="text" :class="{'hide':!this.showSheet}" :disabled='sending'>
        <div class='blank' :class="{'hide':!this.showSheet}" ></div>
        <input class="tube-input profile-brief-item" v-model="newDes" placeholder="new des" type="text" :class="{'hide':!this.showSheet}" :disabled='sending'>
        <div class='blank' :class="{'hide':!this.showSheet}" ></div>
        <input class="tube-input profile-brief-item" v-model="newPasswd" placeholder="new password" type="password" :class="{'hide':!this.showSheet}" :disabled='sending'>
        <div class='blank' :class="{'hide':!this.showSheet}" ></div>
        <button class="tube-button profile-button profile-brief-item" :class="{'hide':!this.showSheet}" @click='changeInfo' :disabled='sending'>apply change</button>
    </div>
</template>
<script>
export default {
    name: 'profile',
    data:function(){
        return {
            name:'',
            des:'',
            existingUser:true,
            newName:'',
            newDes:'',
            newPasswd:'',
            showSheet:false,
            sending:false
        }
    },
    methods:{
        initialize(){
            // console.log('init');
            this.existingUser=true;
            let contactFinder=0;
            while(contactFinder<this.$store.state.contacts.length){
                if(this.$store.state.contacts[contactFinder].uid===this.uid){
                    this.refreshContact(this.$store.state.contacts[contactFinder]);
                    break;
                }
                contactFinder++;
            }
            if(contactFinder===this.$store.state.contacts.length){
                if(this.$store.state.cachedUser.hasOwnProperty(this.$route.params.uid)){
                    this.refreshContact(this.$store.state.cachedUser[this.$route.params.uid]);
                }else{
                    this.$socket.emit('queryUser',{contacts:[this.$route.params.uid]});
                }
            }
        },
        refreshContact(payload){
            this.name=payload.name;
            this.des=payload.des;
        },
        initChat(){
            this.$socket.emit('initChat',{targetUid:this.uid,sourceUid:this.$store.state.UID});
        },
        addContact(){
            console.log('addContact');
            this.$socket.emit('contactAction',{action:'add',targetUid:this.uid});
        },
        deleteContact(){
            console.log('deleteContact');
            this.$socket.emit('contactAction',{action:'delete',targetUid:this.uid});
            this.$router.push({path:`/home`,replace:true});
        },
        switchChangeSheet(){
            this.showSheet=!this.showSheet;
        },
        changeInfo(){
            this.sending=true;
            let fd=new FormData();
            fd.append('mail',this.$store.state.userMail);
            fd.append('passwd',this.$store.state.userPasswd);
            fd.append('newName',this.newName);
            fd.append('newDes',this.newDes);
            fd.append('newPasswd',this.newPasswd);
            let file = document.querySelector('[type=file]');
            fd.append('upload', file.files[0]);

            this.axios
                .post(this.$store.state.baseUrl+'/changeInfo/user',fd,
                    {
                        headers: {
                            'Content-Type': `multipart/form-data`
                        }
                    }
                )
                .then(res=>{
                    // console.log(res.data);
                    if(res.data.result===1){
                        console.log('change success');
                        this.$store.state.userName=(this.newName.trim() !== '')?this.newName:this.$store.state.userName;
                        this.$store.state.userPasswd=(this.newPasswd.trim() !== '')?this.newPasswd:this.$store.state.userName;
                        this.showSheet=!this.showSheet;
                        alert('change success');
                    }else if(res.data.result===2){
                        console.log('change error');
                        alert('change error');
                    }
                    this.newName='';
                    this.newDes='';
                    this.newPasswd='';
                    this.sending=false;
                })
                .catch(err=> {
                    console.log('error');
                    console.log(err);
                });
        }
    },
    watch: {
        '$store.state.contacts': {
            handler: function(newer, older) { 
                let contactFinder=0;
                while(contactFinder<newer.length){
                    if(newer[contactFinder].uid===this.uid){
                        this.contact=newer[contactFinder];
                        break;
                    }
                    contactFinder++;
                }
            },
            deep: true 
        },
        '$route.params.uid':{
            handler: function(newer, older) { 
                if(newer !== older){
                    this.initialize();
                }
            },
            deep: true 
        }
    },
    computed:{
        url(){
            return this.$store.state.baseUrl+'/userPic/'+this.$route.params.uid
        },
        relation(){
            if(this.uid === this.$store.state.UID){
                // user himself/herself
                return 2
            }else if(this.$store.state.contactIndex.indexOf(this.uid) !== -1){
                // contact
                return 1
            }else{
                // stranger
                return 0
            }
        },
        uid(){
            return parseInt(this.$route.params.uid)
        }
    },
    mounted(){
        this.initialize();
    },
    sockets:{
        notFoundUser:function(payload){
            this.contact.name='404';
            this.contact.des='not found';
            this.existingUser=false;
        },
        queryUserBack:function(payload){
            this.refreshContact(payload[0]);
            this.$store.commit('cacheUser',payload);
        }
    }
}
</script>
<style>
    .profile-icon {
        margin-top:48px;
        margin-bottom:8px;
        max-width: 180px;
        max-height: 180px;
        width: 40vw;
        height: 40vw;
        border-radius: 50%;
        overflow: hidden;
        background-color: #b0bec5;
        align-self: center;
    }

    .profile-icon img {
        max-height:100%; 
        max-width:100%;
        object-fit: contain;
    }

    .profile-brief-item {
        align-self: center;
        max-width: 320px;
        margin-bottom: 6px;
    }

    .profile-name {
        font-size: 28px;
    }

    .profile-description {
        font-size: 20px;
        overflow:hidden;  
        text-overflow: ellipsis;
    }

    .profile-button {
        min-width: 150px;
    }
</style>

